import { gameSelectors } from '~/store/selectors';
import GameService from '~/services/game.service';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

import { LEVEL_STARTED_LEVEL_1 } from '../level/actionTypes';
//	---- parent imports ----

export function setStoreName(storeName) {
	return async (dispatch, getState) => {

		const result = await GameService.saveStoreName(
			gameSelectors.getGameId(getState()),
			storeName
		);

		if (!result.isSuccess) {
			return;
		}
		dispatch({ type: types.STORE_SET_NAME, storeName });
		dispatch({ type: LEVEL_STARTED_LEVEL_1 })	//	to show briefcase hint

	};
}

export function storeLoaded(store) {
	return async (dispatch) => {
		dispatch({ type: types.STORE_LOADED, store });
	};
}

export function setStoreSelected(store) {
	return async (dispatch) => {
		dispatch({ type: types.STORE_SELECTED, store });
	};
}
